import React from "react";
import ErrorPage from "../Notification/Error";

function ConfirmationPage({ props }) {
  const {
    data,
    bank,
    loadBank,
    onSelect,
    onChange,
    isError,
    loading,
    onSubmit,
    onFile,
    method,
  } = props;

  return (
    <div className="history-detail">
      <div className="container mx-auto py-6 lg:py-10">
        {/* Ini Breadcrumb */}
        <div name="breadecrumb" className="flex items-center mb-6 lg:mb-8">
          <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-gray">
            Home
          </p>
          <img
            className="mr-3 lg:mr-5"
            src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_arrow.svg"}
            alt="icon-arrow"
          />
          <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-gray">
            Riwayat
          </p>
          <img
            className="mr-3 lg:mr-5"
            src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_arrow.svg"}
            alt="icon-arrow"
          />
          <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-blue">
            Konfirmasi Pembayaran
          </p>
        </div>

        {/* Ini Content */}

        <div className="w-full flex justify-center">
          <div className="detail-wrapper w-full lg:w-3/5 p-2 lg:px-24 lg:py-10">
            <p className="header-title-bold text-xl lg:text-3xl colors-blue font-bold mb-3 lg:mb-4 text-center">
              Konfirmasi Pembayaran
            </p>
            <p className="header-cotent colors-gray text-center text-base mb-10">
              Konfirmasi pembayaran anda dengan mengisi form dibawah ini
            </p>

            {/* Mulai Input */}
            {method === 2 && (
              <>
                <div name="bank-form" className="mb-7">
                  <p className="login-title-form mb-3 text-xl lg:text-2xl">
                    Bank Asal
                  </p>
                  <select
                    onChange={onSelect}
                    disabled={loadBank}
                    value={data?.bank_asal ?? 0}
                    name="bank_asal"
                    className="form-input outline-none w-full p-3 pr-4"
                    placeholder="Pilih bank asal"
                  >
                    <option className="colors-gray" disabled selected value={0}>
                      Pilih bank asal
                    </option>
                    {bank.map((it, idx) => (
                      <option key={idx} value={it.id}>
                        {it.name}
                      </option>
                    ))}
                  </select>

                  {isError
                    ? isError.length > 0
                      ? isError
                          .filter((it) => it.type === "bank_asal")
                          .map((its, idx) => (
                            <ErrorPage
                              key={idx}
                              props={{ idx, message: its.message }}
                            />
                          ))
                      : null
                    : null}
                </div>

                <div className="grid grid-cols-1 grid-rows-1 lg:grid-cols-2 gap-5 mb-7">
                  <div name="rekening-asal-form">
                    <p className="login-title-form mb-3 text-xl lg:text-2xl">
                      Rekening Asal
                    </p>
                    <input
                      value={data.account_number}
                      pattern="[0-9]*"
                      onChange={onChange}
                      name="account_number"
                      className="form-input outline-none w-full p-3"
                      placeholder="Tuliskan no. rekening anda"
                    />

                    {isError
                      ? isError.length > 0
                        ? isError
                            .filter((it) => it.type === "account_number")
                            .map((its, idx) => (
                              <ErrorPage
                                key={idx}
                                props={{ idx, message: its.message }}
                              />
                            ))
                        : null
                      : null}
                  </div>
                  <div name="nama-rekening-form">
                    <p className="login-title-form mb-3 text-xl lg:text-2xl">
                      Nama Rekening
                    </p>
                    <input
                      value={data.account_name}
                      onChange={onChange}
                      name="account_name"
                      className="form-input outline-none w-full p-3"
                      placeholder="Tuliskan nama rekening anda"
                    />

                    {isError
                      ? isError.length > 0
                        ? isError
                            .filter((it) => it.type === "account_name")
                            .map((its, idx) => (
                              <ErrorPage
                                key={idx}
                                props={{ idx, message: its.message }}
                              />
                            ))
                        : null
                      : null}
                  </div>
                </div>
              </>
            )}
            <div name="bukti-transfer-form">
              <p className="login-title-form mb-3 text-xl lg:text-2xl">
                Upload Bukti Transfer
              </p>
              <div className="flex w-full items-center">
                <input
                  disabled
                  value={data?.bukti_transfer ?? "Pilih bukti transfer"}
                  name="bukti_transfer"
                  className="input-disabled outline-none w-3/4 p-3"
                  placeholder="Pilih bukti transfer"
                />
                <input
                  name="bukti_transfer"
                  type="file"
                  className="custom-file-input lg:w-1/4"
                  onChange={onFile}
                />
              </div>

              {isError
                ? isError.length > 0
                  ? isError
                      .filter((it) => it.type === "bukti_transfer")
                      .map((its, idx) => (
                        <ErrorPage
                          key={idx}
                          props={{ idx, message: its.message }}
                        />
                      ))
                  : null
                : null}
            </div>
            <button
              disabled={loading}
              onClick={onSubmit}
              className={`${
                loading ? "btn-loading" : "btn-blue"
              } p-3 focus:outline-none w-full mt-10 mb-5`}
            >
              <p className="text-white font-semibold lg:text-lg">
                {loading ? "Loading" : "Simpan Data Pembayaran"}
              </p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationPage;
